module.exports = __webpack_public_path__ + "static/img/temp_id_card.2d5913a.png";


//////////////////
// WEBPACK FOOTER
// ./static/preview_img/temp_id_card.png
// module id = kwCT
// module chunks = 43